import { LAYOUTS, } from '@voltmoney/types';
import { ActiveStateTokens, AvatarSizeTokens, AvatarTypeTokens, BorderRadiusTokens, ColorTokens, IconTokens, SizeTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { aboutDetails, accountDetails, contactDetails, faqDetails, goBack, logout, navigateForeClosureTracking, navigateToForeclosure, navigateToHelpAndSupport, navigateToLoanDetails, } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { shouldShowVoltContactUs } from '../../../configs/uri-config-utils';
import { CREDIT_STATUS, formatFullName, getBorrowerProfile, getManageLimitConfig, removeUrlWithoutReload, showHelpAndSupportField, showNewForeClosureFlow, showUserLoanDetils, getBiometricsPermissionFromFirebase } from '../../../configs/utils';
import { foreclosureTrackingFlag, QUERY_PARAMS, TARGET_PAGES } from '../../../configs/constants';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import AsyncStorage from '@react-native-async-storage/async-storage';
const menuList = (profileData, shouldShowContactUs, showForeclosure, preLoanFlowUI, showLogout, isLoanExpired, showForeclosureTracking, foreclosureTrackingResponse, showForeclosureTrackingFromFirebase, setIsUserLoggedIn, setShowSupportPhoneNumber, isLoanRenewalInProgress, showLoanDetails, showNewForeClosureScreen, showHelpAndSupport, userName, hideAboutUs, hideFaq) => {
    const menuList = [
        {
            id: 'txt_profileScreen_accountDetails',
            iconName: IconTokens.Account_profile,
            title: 'Account details',
            titleColor: ColorTokens.Grey_Night,
            action: {
                type: ACTION.PROFILE,
                payload: {
                    value: profileData,
                },
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_loanDetails',
            iconName: IconTokens.MY_LOAN_PROFILE_ICON,
            title: 'My loan details',
            titleColor: ColorTokens.Grey_Night,
            action: {
                type: ACTION.LOAN_PROFILE,
                payload: {},
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_FAQ',
            iconName: IconTokens.Question,
            title: 'FAQs',
            titleColor: ColorTokens.Grey_Night,
            action: {
                type: ACTION.FAQ,
                payload: {},
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_helpAndSupport',
            iconName: IconTokens.HeadPhone,
            title: 'Help and support',
            titleColor: ColorTokens.Grey_Night,
            action: {
                type: ACTION.HELP_AND_SUPPORT,
                payload: { userName: userName },
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_contactUs',
            iconName: IconTokens.HeadPhone,
            title: 'Contact us',
            titleColor: ColorTokens.Grey_Night,
            action: {
                type: ACTION.CONTACT_US,
                payload: {},
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_trackClosureRequest',
            iconName: IconTokens.foreclosure,
            title: 'Track closure request',
            action: {
                type: ACTION.TRACK_FORECLOSURE,
                payload: {
                    value: foreclosureTrackingResponse,
                },
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_loanForeclosure',
            iconName: IconTokens.foreclosure,
            title: showNewForeClosureScreen ? 'Close account' : 'Loan closure',
            action: {
                type: ACTION.FORECLOSE,
                payload: { showNewForeClosureScreen },
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_aboutUs',
            iconName: IconTokens.AboutUs,
            title: 'About us',
            action: {
                type: ACTION.ABOUT,
                payload: {},
                routeId: ROUTE.MY_PROFILE,
            },
        },
    ];
    const filteredList = () => {
        const idsToRemove = [];
        if (isLoanRenewalInProgress) {
            idsToRemove.push('txt_profileScreen_loanForeclosure');
        }
        if (!showLoanDetails) {
            idsToRemove.push('txt_profileScreen_loanDetails');
        }
        if (!shouldShowContactUs) {
            idsToRemove.push('txt_profileScreen_contactUs');
        }
        if (showForeclosure || isLoanExpired) {
            idsToRemove.push('txt_profileScreen_loanForeclosure', 'txt_profileScreen_trackClosureRequest');
        }
        if (hideAboutUs) {
            idsToRemove.push('txt_profileScreen_aboutUs');
        }
        if (hideFaq) {
            idsToRemove.push('txt_profileScreen_FAQ', 'txt_profileScreen_helpAndSupport');
        }
        if (preLoanFlowUI) {
            if (showForeclosureTracking) {
                if (showForeclosureTrackingFromFirebase) {
                    idsToRemove.push('txt_profileScreen_loanForeclosure');
                }
                else {
                    idsToRemove.push('txt_profileScreen_trackClosureRequest', 'txt_profileScreen_loanForeclosure', 'txt_profileScreen_aboutUs');
                }
            }
            else {
                idsToRemove.push('txt_profileScreen_accountDetails', 'txt_profileScreen_trackClosureRequest', 'txt_profileScreen_loanForeclosure');
            }
        }
        else if (!showForeclosure) {
            idsToRemove.push('txt_profileScreen_trackClosureRequest');
        }
        if (!showLogout) {
            idsToRemove.push('txt_profileScreen_logOut');
        }
        if (showHelpAndSupport) {
            idsToRemove.push('txt_profileScreen_loanForeclosure');
            idsToRemove.push('txt_profileScreen_contactUs');
            idsToRemove.push('txt_profileScreen_FAQ');
        }
        else {
            idsToRemove.push('txt_profileScreen_helpAndSupport');
        }
        return menuList.filter(item => !idsToRemove.includes(item.id));
    };
    return filteredList;
    // if(isLoanRenewalInProgress){
    //     list.splice(4, 1)
    // }
    // if (!shouldShowContactUs) {
    //     list.splice(2, 1)
    // }
    // if (showForeclosure || isLoanExpired) {
    //     list.splice(4, 1)
    //     list.splice(3, 1)
    // }
    // if (preLoanFlowUI) {
    //     if (showForeclosureTracking) {
    //         if (showForeclosureTrackingFromFirebase) {
    //             list.splice(4, 1)
    //         } else {
    //             list.splice(4, 1)
    //             list.splice(5, 1)
    //             list.splice(3, 1)
    //         }
    //     } else {
    //         list.splice(0, 1);
    //         list.splice(3, 1);
    //         list.splice(2, 1);
    //     }
    // } else if(!showForeclosure) {
    //     list.splice(3, 1)
    // }
    // if (!showLogout) {
    //     list?.pop();
    // }
    // return list
};
export const template = (userName, initialUserLetter, profileData, showContactUs, isPendingForeclosure, preLoanFlowUI, showLogout, isLoanExpired, showForeclosureTracking, foreclosureTrackingResponse, showForeclosureTrackingFromFirebase, setIsUserLoggedIn, setShowSupportPhoneNumber, isLoanRenewalInProgress, showLoanDetails, showNewForeClosureScreen, height, biometricsPermissionFromFirebase, showHelpAndSupport, hideAboutUs, hideFaq) => {
    return {
        layout: {
            id: ROUTE.MY_PROFILE,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true,
            },
            widgets: [{ id: 'myProfile', type: WIDGET.BLUR_VIEW_SCREEN }],
        },
        datastore: {
            myProfile: {
                height: height,
                userName: userName,
                rightItem: {
                    uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/profile_pre1.png',
                    initialLetter: `${initialUserLetter}`,
                    type: AvatarTypeTokens.SINGLE,
                    size: AvatarSizeTokens.LG,
                    active: ActiveStateTokens.INACTIVE,
                    borderWidth: 1,
                    borderColor: ColorTokens.Primary_100,
                    borderRadius: BorderRadiusTokens.BR5,
                },
                headerAction: {
                    type: ACTION.BACK_BUTTON,
                    payload: {},
                    routeId: ROUTE.MY_PROFILE,
                },
                accountDetailsAction: {
                    type: ACTION.PROFILE,
                    payload: {
                        value: profileData,
                    },
                    routeId: ROUTE.MY_PROFILE,
                },
                myLoanDetailsAction: {
                    type: ACTION.LOAN_PROFILE,
                    payload: {},
                    routeId: ROUTE.MY_PROFILE,
                },
                faqsAction: {
                    type: ACTION.FAQ,
                    payload: {},
                    routeId: ROUTE.MY_PROFILE,
                },
                contactUsAction: {
                    type: ACTION.CONTACT_US,
                    payload: {},
                    routeId: ROUTE.MY_PROFILE,
                },
                loanClosureAction: {
                    type: ACTION.FORECLOSE,
                    payload: { showNewForeClosureScreen },
                    routeId: ROUTE.MY_PROFILE,
                },
                trackForeclosureRequestAction: {
                    type: ACTION.TRACK_FORECLOSURE,
                    payload: {
                        value: foreclosureTrackingResponse,
                    },
                    routeId: ROUTE.MY_PROFILE,
                },
                aboutUsAction: {
                    type: ACTION.ABOUT,
                    payload: {},
                    routeId: ROUTE.MY_PROFILE,
                },
                isLoanRenewalInProgress: isLoanRenewalInProgress,
                showLoanDetails: showLoanDetails,
                shouldShowContactUs: showContactUs,
                showForeclosure: isPendingForeclosure,
                isLoanExpired: isLoanExpired,
                showLogout: showLogout,
                filteredList: menuList(profileData, showContactUs, isPendingForeclosure, preLoanFlowUI, showLogout, isLoanExpired, showForeclosureTracking, foreclosureTrackingResponse, showForeclosureTrackingFromFirebase, setIsUserLoggedIn, setShowSupportPhoneNumber, isLoanRenewalInProgress, showLoanDetails, showNewForeClosureScreen, showHelpAndSupport, userName, hideAboutUs, hideFaq),
                onLogoutAction: {
                    type: ACTION.LOGOUT,
                    payload: {
                        setIsUserLoggedIn: setIsUserLoggedIn,
                        setShowSupportPhoneNumber: setShowSupportPhoneNumber,
                    },
                    routeId: ROUTE.MY_PROFILE,
                },
                biometricsPermissionFromFirebase: biometricsPermissionFromFirebase
            },
            spaceXXL: {
                size: SizeTypeTokens.XXL,
            },
        },
    };
};
export const myProfileMF = {
    onLoad: async ({ network, getHeight }, { response, target, setIsUserLoggedIn, setShowSupportPhoneNumber }) => {
        const showLogout = await SharedPropsService.getShowLogout();
        const user = await SharedPropsService.getUser();
        let preLoanFlowUI = false;
        let isPendingForeclosure = user?.linkedCredits[0]?.creditStatus === "PENDING_CLOSURE";
        const showNewForeClosureScreen = await showNewForeClosureFlow();
        const showHelpAndSupport = await showHelpAndSupportField();
        let showLoanDetails = false;
        const creditStatus = user?.linkedCredits[0]?.creditStatus;
        const showUserLoanDetailsFlow = await showUserLoanDetils();
        if ((creditStatus === CREDIT_STATUS.APPROVED_NOT_DISBURSED || creditStatus === CREDIT_STATUS.ACTIVE) && showUserLoanDetailsFlow === true) {
            showLoanDetails = true;
        }
        else
            showLoanDetails = false;
        if (user.linkedApplications[0].applicationState === "COMPLETED") {
            // const manageLimitConfig = await network
            //     .get(
            //         `${api.manageLimitConfig}${user.linkedCredits[0].creditId}`, {headers: await getAppHeader()}).then(response => response.data)
            const manageLimitConfig = await getManageLimitConfig(network);
            let showNewFlow = manageLimitConfig.loanForeClosureAllowed;
            if (!isPendingForeclosure) {
                if (showNewFlow) {
                    isPendingForeclosure = false;
                }
                else {
                    isPendingForeclosure = true;
                }
            }
            preLoanFlowUI = false;
        }
        else
            preLoanFlowUI = true;
        // const responseX = response
        //     ? response
        //     : await network
        //         .get(
        //             `${api.userProfile}${user.linkedBorrowerAccounts[0].accountId}`,
        //             {headers: await getAppHeader()},
        //         )
        //         .then(response => response.data)
        const borrowerUserProfile = await getBorrowerProfile(network, {
            overrideCache: true
        });
        // const phoneNumber = responseX?.phoneNumber;
        // const updatedPhoneNumber = phoneNumber.slice(0, 3) + " " + phoneNumber.slice(3, phoneNumber.length);
        // const userName: string = (responseX?.name === null || responseX?.name === undefined) ? updatedPhoneNumber : responseX?.name
        // const formattedFullName = formatFullName(userName);
        const phoneNumber = borrowerUserProfile?.phoneNumber;
        const updatedPhoneNumber = phoneNumber.slice(0, 3) + " " + phoneNumber.slice(3, phoneNumber.length);
        const userName = (borrowerUserProfile?.name === null || borrowerUserProfile?.name === undefined) ? updatedPhoneNumber : borrowerUserProfile?.name;
        const formattedFullName = formatFullName(userName);
        const initialUserLetter = userName?.charAt(0) === "+" ? "" : userName?.charAt(0);
        const showContactUs = shouldShowVoltContactUs(await SharedPropsService.getURL());
        // const profileData = responseX
        const profileData = borrowerUserProfile;
        await AsyncStorage.removeItem("target");
        if (target && target === TARGET_PAGES.ACCOUNT) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        const isLoanExpired = await SharedPropsService.getIsLoanExpired();
        const isLoanRenewalInProgress = await SharedPropsService.getIsInProgressLoanRenewal();
        let showForeclosureTracking = false;
        let foreclosureTrackingResponse;
        const showForeclosureTrackingFromFirebase = await foreclosureTrackingFlag();
        const hideAboutUs = user?.linkedPlatformAccounts[0]?.platformSDKConfig?.showUserProfileAboutUs === false;
        const hideFaq = user?.linkedPlatformAccounts[0]?.platformSDKConfig?.showUserProfileFaq === false;
        if (user.linkedApplications[0].applicationState === 'IN_PROGRESS') {
            if (showForeclosureTrackingFromFirebase) {
                const getLoanForeclosureCompletedData = await network
                    .get(`${api.getForeclosureCompleted}${user.linkedBorrowerAccounts[0].accountId}`, { headers: await getAppHeader() });
                if (getLoanForeclosureCompletedData?.response?.data?.statusCode === "400") {
                    showForeclosureTracking = false;
                }
                else {
                    showForeclosureTracking = true;
                    foreclosureTrackingResponse = getLoanForeclosureCompletedData?.data;
                }
            }
        }
        const biometricsPermissionFromFirebase = await getBiometricsPermissionFromFirebase();
        return Promise.resolve(template(formattedFullName, initialUserLetter, profileData, showContactUs, isPendingForeclosure, preLoanFlowUI, showLogout, isLoanExpired, showForeclosureTracking, foreclosureTrackingResponse, showForeclosureTrackingFromFirebase, setIsUserLoggedIn, setShowSupportPhoneNumber, isLoanRenewalInProgress, showLoanDetails, showNewForeClosureScreen, getHeight(), biometricsPermissionFromFirebase, showHelpAndSupport, hideAboutUs, hideFaq));
    },
    actions: {
        [ACTION.PROFILE]: accountDetails,
        [ACTION.CONTACT_US]: contactDetails,
        [ACTION.FAQ]: faqDetails,
        [ACTION.BACK_BUTTON]: goBack,
        [ACTION.LOGOUT]: logout,
        [ACTION.ABOUT]: aboutDetails,
        [ACTION.FORECLOSE]: navigateToForeclosure,
        [ACTION.TRACK_FORECLOSURE]: navigateForeClosureTracking,
        [ACTION.LOAN_PROFILE]: navigateToLoanDetails,
        [ACTION.HELP_AND_SUPPORT]: navigateToHelpAndSupport,
    },
    bgColor: '#FFFFFF',
};
